import { Routes } from '@angular/router';
import { devOnlyGuard } from '@guards/dev-only.guard';
import { noAuthGuard } from '@guards/no-auth.guard';
import { PublicLayoutComponent } from 'app/layout/public-layout/public-layout.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetPasswordConfirmComponent } from './reset-password-confirm/reset-password-confirm.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

const routes: Routes = [
	{
		path: '',
		component: PublicLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full',
			},
			{
				path: 'login',
				component: LoginComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'verify-email',
				component: VerifyEmailComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
				canActivate: [noAuthGuard],
			},
			{
				path: 'reset-password-confirm',
				component: ResetPasswordConfirmComponent,
			},
			{
				// Dev-only showcase (~8k lines). `devOnlyGuard` blocks the
				// navigation, but a static import still shipped every byte of it
				// in the initial bundle: loaded lazily so it only travels when
				// someone actually opens it (auditoría 2026-07-27).
				path: 'ui-kit',
				loadComponent: () => import('./ui-kit/ui-kit.component').then((m) => m.UiKitComponent),
				canActivate: [devOnlyGuard],
			},
		],
	},
];

export default routes;
